import { render, staticRenderFns } from "./TooltipWrapper.vue?vue&type=template&id=ac1168a2&"
import script from "./TooltipWrapper.vue?vue&type=script&lang=ts&"
export * from "./TooltipWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports